<template>
  <footer id="kt_footer" class="nv-footer">
    <div class="nv-container nv-footer__inner">
      <div class="nv-footer__copy">
        {{ CurrentYear }} © Nilvera Yazılım ve Bilişim Hizmetleri
      </div>
      <nav class="nv-footer__links">
        <a href="https://nilvera.com/" target="_blank" rel="noopener">nilvera.com</a>
        <a href="mailto:destek@nilvera.com">destek@nilvera.com</a>
        <a href="tel:08502514010">0850 251 40 10</a>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: "KTFooter",
  data() {
    return {
      CurrentYear: new Date().getFullYear()
    }
  }
};
</script>
